import React, { useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { GiHamburgerMenu } from 'react-icons/gi';

import DemoWarning from 'components/common/demoWarning/DemoWarning';
import DeleteConfirmation from 'components/common/DeleteConfirmation';
import AddNew from './AddNew';

import { getCurrentUser, getUsersAccessPoints } from 'actions/userActions';
import { deleteDemoData, getPricingMatrices, getTenantSettings } from 'actions/tenantActions';

import User from 'models/UserModel';

import modalResources from 'helpers/resources/modals';
import axios from 'helpers/axios';
import config from 'helpers/config';
import actionTypes from 'helpers/actionTypes';
import UserAvatar from './UserAvatar';
import Notifications from './Notifications';
import RecentRos from './RecentRos';
import SuperSearch from './SuperSearch';
import { FaWrench } from 'react-icons/fa';
import Tenant from 'models/TenantModel';

interface Props {
    companyName?: string;
    currentUser?: User;
    tenant: Tenant;
    dispatch: Dispatch;
}

const NavigationBar: React.FC<Props> = (props: Props) => {
    const { currentUser, dispatch } = props;

    const [isDeleteDemoDataOpen, setIsDeleteDemoDataOpen] = useState(false);

    if (!props.currentUser) {
        dispatch<any>(getCurrentUser());
        dispatch<any>(getUsersAccessPoints());
        dispatch<any>(getTenantSettings());
        dispatch<any>(getPricingMatrices());
    }

    const handleDeleteDemoData = (deleteData: boolean) => {
        if (deleteData) {
            const { dispatch } = props;
            dispatch<any>(deleteDemoData());
        }
        setIsDeleteDemoDataOpen(false);
    };

    const toggleSidebar = () => {
        const { userSetting } = currentUser!;
        userSetting.isSideBarCollapsed = !userSetting.isSideBarCollapsed;
        dispatch({ type: actionTypes.UPDATE_USER_SETTINGS_SUCCESS, payload: userSetting });
        axios.put(`${config.apiUrl}/user/settings`, userSetting);
    };

    return (
        <div className="header-container">
            <div style={{ backgroundColor: '' }} className="header bg-slate-800 border-b border-blue-600 shadow-lg ">
                {!!currentUser && <DemoWarning user={currentUser} />}
                <div className="header__header-bar">
                    <div className="p-2 rounded-full hover:bg-gray-400 ml-4 clickable" onClick={() => toggleSidebar()}>
                        <GiHamburgerMenu className="text-white clickable text-2xl" />
                    </div>
                    <div className="app-name ">
                        {/* <img className="inline" src={`${config.fileRootURL}assets/favicon.png`}></img> */}
                        <FaWrench className="inline text-blue-400 text-2xl mr-2" />
                        <span className="inline font-semibold text-blue-400 ">Shop Link</span>
                    </div>
                    {!!currentUser?.tenant?.hasDemoData && (
                        // change the button design to a more modern look using tailwind classes; also make it responsive
                        <button
                            className="ml-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                            style={{ fontSize: '0.875rem' }}
                            onClick={() => setIsDeleteDemoDataOpen(true)}
                        >
                            {modalResources.DEMO_DATA_REMINDER}
                        </button>
                    )}
                    <DeleteConfirmation
                        isOpen={isDeleteDemoDataOpen}
                        onCancel={() => handleDeleteDemoData(false)}
                        onConfirm={() => handleDeleteDemoData(true)}
                        deletedItem={modalResources.DELETE_DEMO_DATA_CONFIRMATION}
                    ></DeleteConfirmation>
                    <SuperSearch />
                    <div className="ml-auto flex  h-full">
                        <div className="flex items-center space-x-3 mr-3">
                            <RecentRos />
                            <AddNew />
                            <Notifications />
                        </div>
                        {props.currentUser && <UserAvatar user={props.currentUser!} tenant={props.tenant} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    currentUser: state.user.currentUser,
    tenant: state.tenant.tenant,
});

export default connect(mapStateToProps)(NavigationBar);
